import React from 'react'
import cx from 'classnames'

import emitGAOnClick from '@cred/shared/hoc/emitGAOnClick'
import CtaButton from '@cred/react-cta'

import withNofollow from 'components/hocs/with-nofollow'

import styles from './styles.module.scss'

// eslint-disable-next-line react/prop-types
const CtaButtonWithTheme = ({ className, fullWidth, ...restProps }) => {
  const color = restProps.color || 'primary'

  return (
    <CtaButton
      className={cx(className, styles.ctaWithTheme, styles[color], styles[restProps.variant], {
        [styles.height]: restProps.size !== 'small',
        [styles.fullWidth]: fullWidth,
        [styles.disabled]: restProps.showDisabled,
      })}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
    />
  )
}

const CtaButtonWithAnalytics = emitGAOnClick(withNofollow(CtaButtonWithTheme))

export { CtaButton }
export default CtaButtonWithAnalytics
